import { render, staticRenderFns } from "./homeDashboardMembercardStatistics.vue?vue&type=template&id=71e97f40&scoped=true"
import script from "./homeDashboardMembercardStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardMembercardStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e97f40",
  null
  
)

export default component.exports